<template>
    <div id="printReport">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
                </div>
                <div class="col-sm-8">
                    <h3 class="text-center">Relatório de Pós Venda</h3>
                </div>
                <div class="col-sm-2"></div>
            </div>
            <div class="row mt-3" id="conteudo">
                <div class="col-sm-12">
                    <div class="panel panel-defaul">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <label>Data da chegada da Venda no Pós venda</label>
                                    <br />
                                    <div >{{ form.created_at.length ? moment(form.created_at[0]).format('DD/MM/YYYY') : 'Todas' }} à {{ form.created_at.length ? moment(form.created_at[1]).format('DD/MM/YYYY') : 'Todas' }}</div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-4">
                                    <label>Loja</label>
                                    <br />
                                    <div>{{ branches.find(branche => branche.id === form.branch_id).name }}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Equipe</label>
                                    <br />
                                    <div>{{ form.team_id ? teams.find(team => team.id === form.team_id).name : 'Todas' }}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Representante</label>
                                    <br />
                                    <div>{{ form.representative_id ? representatives.find(representative => representative.id === form.representative_id).name : 'Todos' }}</div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-4">
                                    <label>Status</label>
                                    <br />
                                    <div>{{ form.status_id ? after_sale_status.find(after_sale_state => after_sale_state.id === form.status_id).status : 'Todos' }}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Situação</label>
                                    <br />
                                    <div>{{ form.situation ? situations.find(situation => situation.id === form.situation).name : 'Todas' }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-md-12 text-center">
                    <div style="max-height: 400px; max-width: 600px; margin: 0 auto;">
                        <apexchart type="pie" :options="chartOptions" :series="series"></apexchart>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="panel panel-defaul">
                        <div class="panel-body" style="overflow-x: auto;">
                            <table id="tabela" class="table b-table table-sm">
                                <thead>
                                    <tr>
                                        <th>Contrato</th>
                                        <th>Grupo</th>
                                        <th>Cota</th>
                                        <th>Cliente</th>
                                        <th>CPF/CNPJ</th>
                                        <th>Status</th>
                                        <th>Situação</th>
                                        <th>Representante</th>
                                        <th>Tempo para 1º Atendimento</th>
                                        <th>Data chegada no Pós Venda</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="afterSale in report_data">
                                        <td>{{ afterSale.physical_proposal }}</td>
                                        <td>{{ afterSale.group }}</td>
                                        <td>{{ afterSale.quota }}</td>
                                        <td>{{ afterSale.client_name }}</td>
                                        <td>{{ afterSale.cpf_cnpj }}</td>
                                        <td>{{ afterSale.status }}</td>
                                        <td>{{ afterSale.situation == 'A' ? 'Alocada' : (afterSale.situation == 'C' ? 'Cancelada' : 'Não alocada') }}</td>
                                        <td>{{ afterSale.representative_name }}</td>
                                        <td>{{ afterSale.first_contact_at ? differenceDates(afterSale.first_contact_at, afterSale.created_at) : 'Ainda não atendido' }}</td>
                                        <td>{{ afterSale.created_at | moment('DD/MM/YYYY') }}</td>
                                        <td>
                                            <router-link
                                                data-original-title
                                                title="Histórico de pós venda do contrato"
                                                class="btn btn-outline-primary btn-link"
                                                tag="button"
                                                :to="{
                                                    name: 'reports.print-after-sales.history', 
                                                    params: {
                                                        id: afterSale.id
                                                    }, 
                                                    query: $route.query
                                                }"
                                                >
                                                <i class="material-icons">find_in_page</i>
                                            </router-link>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container dont-print mt-3">
            <div class="row">
                <div class="col-md-12 text-center">
                    <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
                    <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
                </div>
            </div>
        </div>
        <b-modal
            ref="modal"
            dialog-class="modal-lg"
            hide-footer
            scrollable
            :visible="$route.meta.showModal"
            :title="$route.meta.title"
            @hide="hideModal"
            >
            <router-view name="modal" />
        </b-modal>
    </div>
</template>

<script>
    import Vue from "vue";
    import VueApexCharts from "vue-apexcharts";

    export default {
        components: {
            apexchart: VueApexCharts,
        },
        computed: {
            after_sale_status() {
                var afterStatus = [
                    {
                        id: null,
                        status: "Todos"
                    }
                ];
                return afterStatus.concat(this.$store.state.after_sale_status.itens);
            },
            branches() {
                return this.$store.state.defaults.branches;
            },
            chartOptions() {
                if (this.$store.state.after_sale_status.itens.length > 0) {
                    return {
                        chart: {
                            type: 'pie',
                            height: "250px",
                            width: "600px",
                            events: {
                                dataPointSelection: (event, chartContext, opts) => {
                                    this.setFilterByStatus(this.$store.state.after_sale_status.itens[opts.dataPointIndex].status);
                                }
                            }
                        },
                        stroke: {
                            colors: ['#000']
                        },
                        fill: {
                            opacity: 0.8
                        },
                        labels: this.$store.state.after_sale_status.itens.map(status => status.status),
                        responsive: [
                            {
                                breakpoint: 480,
                                options: {
                                    chart: {
                                        width: 600
                                    },
                                    legend: {
                                        position: 'bottom'
                                    }
                                }
                            }
                        ]
                    };
                }
                return {};
            },
            report_data() {
                if (this.filterByStatus) {
                    return this.$store.state.reports.item.filter(afterSale => afterSale.status === this.filterByStatus);
                }

                return this.$store.state.reports.item;
            },
            representatives() {
                var salesmans = [
                    {
                        id: null,
                        name: "Todos"
                    }
                ];
                return salesmans.concat(this.$store.state.users.salesmans);
            },
            series() {
                var series = [];
                if (this.$store.state.after_sale_status.itens.length > 0 && this.$store.state.reports.item.length > 0) {
                    this.$store.state.after_sale_status.itens.forEach(status => {
                        series.push(this.$store.state.reports.item.filter(afterSale => afterSale.status === status.status).length);
                    });
                }
                return series;
            },
            teams: {
                get() {
                    return this.$store.state.teams.itens;
                }
            }
        },
        created() {
            var self = this;
            
            self.getAfterSaleStatus();

            self.form = JSON.parse(self.$route.query.form);

            this.$root.$on("hideModal", () => {
                this.$refs.modal.hide();
            });
        },
        data() {
            return {
                filterByStatus: null,
                moment: Vue.moment,
                store_branch: null,
                situations: [
                    {
                        id: "A",
                        name: "Alocada"
                    },
                    {
                        id: "C",
                        name: "Cancelada"
                    },
                    {
                        id: "N",
                        name: "Não alocada"
                    },
                    {
                        id: "T",
                        name: "Todas"
                    }
                ],
            };
        },
        methods: {
            close() {
                window.opener.focus();
                window.close();
            },
            differenceDates(firstDate, secondDate) {
                const differenceInHours = Vue.moment(firstDate).diff(Vue.moment(secondDate), 'hours');

                if (differenceInHours < 24) {
                    return differenceInHours + ' horas';
                }

                return Vue.moment(firstDate).diff(Vue.moment(secondDate), 'days') + ' dias';
            },
            async getAfterSaleStatus() {
              var self = this;

              self.$root.$emit('onLoading');
              const response = self.$store.dispatch('after_sale_status/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                    self.getSalesmans();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.getSalesmans();
                });
            },
            async getReportData() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch(
                    'reports/afterSales',
                    self.form
                );

                response.then(function () {
                    self.$root.$emit('onLoading');
                });
                
            },
            async getSalesmans() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('users/getSalesmans', {all_users:true});

                response.then(() => {
                    self.$root.$emit('onLoading');

                    self.getTeams();
                });

                response.catch(() => {
                    self.$root.$emit('onLoading');

                    self.getTeams();
                });
            },
            async getTeams() {
                var self = this;

                self.$root.$emit('onLoading');

                const response =  self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit("onLoading");

                    self.getReportData();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");

                    self.getReportData();
                });
            },
            hideModal() {
                this.$router.go(-1);
            },
            print() {
                window.print();
            },
            setFilterByStatus(status) {
                if (this.filterByStatus === status) {
                    this.filterByStatus = null;
                } else {
                    this.filterByStatus = status;
                }
            }
        }
    };
</script>
